import TriggerStatic from './TriggerStatic/TriggerStatic';
import {types} from './types';

function Actions(action, showAlert, variables, setOpenVariable, automId, variableRender, automVersionId) {
    if (action.actionName === types.TRIGGER)
        return <TriggerStatic action={action} variables={variables} setOpenVariable={setOpenVariable}
                              variableRender={variableRender} automId={automId} automVersionId={automVersionId}/>;
}

export default Actions;
